
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { IRootState } from "@/store/types";
import {
  required,
  maxLength,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import { TASK } from "@/store/task";

export default Vue.extend({
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    applicationId() {
      return (
        store.state.application.applicationData &&
        store.state.application.applicationData.id
      );
    },
    task() {
      return store.state.application.creditOutcomeTask;
    },
    creditLimit: {
      get(): number | null | undefined {
        return (
          store.state.application.applicationData &&
          store.state.application.applicationData.creditLimit
        );
      },
      set(value: number) {
        store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_CREDIT_LIMIT),
          value
        );
      }
    },
    creditDecisionChangeReason: {
      get(): string | null | undefined {
        return (
          store.state.application.applicationData &&
          store.state.application.applicationData.creditDecisionChangeReason
        );
      },
      set(value: string) {
        store.commit(
          APPLICATION.NS(
            APPLICATION.MUTATIONS.SET_CREDIT_DECISION_CHANGE_REASON
          ),
          value
        );
      }
    },
    showModal: {
      get(): any {
        return !!this.task;
      },
      set(value: any) {
        if (!value) {
          store.commit(
            APPLICATION.NS(APPLICATION.MUTATIONS.SET_CREDIT_OUTCOME_TASK),
            null
          );
          this.resetForm();
        }
      }
    },
    ...mapState({
      decision: (state: IRootState) =>
        state.application.applicationData &&
        state.application.applicationData.creditOutcome,
      reason: (state: IRootState) =>
        state.application.applicationData &&
        state.application.applicationData.creditOutcomeReason
    })
  },
  methods: {
    onChangeCreditLimit() {
      const applicationData = store.state.application.applicationData;

      this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.CHANGE_CREDIT_LIMIT),
        {
          id: applicationData && applicationData.id,
          creditLimit: applicationData && applicationData.creditLimit
        }
      );
    },
    async dispatchAction(action: string) {
      this.isLoading = true;

      const taskId = this.task.taskId;
      const creditDecisionChangeReason = this.creditDecisionChangeReason;
      const creditLimit = this.creditLimit;

      const success = await store.dispatch(action, {
        taskId,
        creditDecisionChangeReason,
        creditLimit
      });

      this.isLoading = false;
      if (success) {
        await this.$store.dispatch(
          APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION),
          this.applicationId
        );
        await this.$store.dispatch(
          TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
          this.applicationId
        );

        this.showModal = false; // hide modal and reset form values

        this.resetForm();
      }
    },
    async onApprove() {
      const action = APPLICATION.NS(
        APPLICATION.ACTIONS.CREDIT_TEAM_APPROVE_APPLICATION
      );

      await this.dispatchAction(action);
    },
    async onFollowUpPg() {
      const action = APPLICATION.NS(APPLICATION.ACTIONS.CREDIT_TEAM_NEED_PG);
      await this.dispatchAction(action);
    },
    async onDecline() {
      const action = APPLICATION.NS(
        APPLICATION.ACTIONS.CREDIT_TEAM_DECLINE_APPLICATION
      );
      await this.dispatchAction(action);
    },
    resetForm() {
      // Do nothing.
    }
  },
  validations: {
    creditDecisionChangeReason: {
      required,
      maxLength: maxLength(200)
    },
    creditLimit: {
      required,
      maxValue: maxValue(100000000),
      minValue: minValue(0)
    }
  }
});
